import ERC20 from "./ERC20.json";
import SwapperRouter from "./SwapperRouter.json";
import FeeCollector from "./FeeCollector.json";
import SwapperTransferProxy from "./SwapperTransferProxy.json";

export const ERC20Abi = ERC20;
export const SwapperRouterAbi = SwapperRouter;
export const FeeCollectorAbi = FeeCollector;
export const SwapperTransferProxyAbi = SwapperTransferProxy;
